import axios from "axios";

export const sendErrorLog = async (
  ErrorHeader: string,
  fullName: string,
  email: string,
  mobilenumber: string,
  apiEndpoint: string,
  errorMessage: string,
  attachments?: Record<string, File>,
  info?: string,
) => {
  const formData = new FormData();

  formData.append("templateId", "78131305-463d-45cf-a168-c3ba3cdd69c9");
  formData.append("senderId", JSON.stringify(5171));

  let additionalMessage = info ?? "";

  if(ErrorHeader === 'Form Submission Error') {
      if (apiEndpoint?.includes("/location") || apiEndpoint?.includes("/admin/users")) {
        additionalMessage = "User was NOT created in the system.";
      } 
      else if (apiEndpoint?.includes("/frcsit-users")) {
        additionalMessage = "User was created in SIS but NOT created in FRCSIT Dashboard.";
      } 
      else if (
        apiEndpoint?.includes("/upload") ||
        apiEndpoint?.includes("/frcsit-user-uploads")
      ) {
        additionalMessage = "User was created but FAILED during file upload process.";
      } 
      else {
        additionalMessage = "Unknown failure occurred during user registration process.";
      }
  }


  formData.append(
    "payload",
    JSON.stringify({
      ErrorHeader: ErrorHeader,
      WebsiteName: "FRCSIT",
      FullName: fullName,
      Email: email,
      PhoneNumber: mobilenumber,
      ApiEndpoint: apiEndpoint,
      ErrorMessage: errorMessage,
      AdditionalMessage: additionalMessage,
      DateTime: new Date().toLocaleString(),
      CurrentYear: new Date().getFullYear(),
    }),
  );

  formData.append(
    "users",
    JSON.stringify([{ sisID: 1233, email: "dev@scieverinc.com" }]),
  );

  const fileNames = [
    "Photograph",
    "Bachelor_Degree",
    "Master_Degree",
    "MCI",
    "Photo_ID",
    "Curriculum_Vitae",
  ];

  if (attachments) {
    Object.values(attachments).forEach((file, index) => {
      formData.append("attachments", file, fileNames[index]);
    });
  }

  await axios.post(
    `${process.env.REACT_APP_NOTIFICATION_URL}/notification/trigger`,
    formData,
  );
};
